import prize1 from "./prize1.png"
import prize2 from "./prize2.png"

export const awards = {
  birthdayglo_points_20_2025: {
    prizeNumber: 3,
    content: {
      title: `<strong>Glückwunsch!</strong> Du hast gewonnen:`,
      content:
        "Glückwunsch! Du hast gewonnen:",
      points: 20,
    },
  },
  birthdayglo_hyper_pro_2025: {
    prizeNumber: 0,
    content: {
      title: "<strong>Wow – Volltreffer!</strong> Du hast gewonnen:",
      content:
        `100 % Rabatt auf ein <strong>glo™<br/> Hyper Pro Device Kit!</strong>`,
      img: prize1,
    },
  },
  birthdayglo_glo_home_stick_tray_2025: {
    prizeNumber: 2,
    content: {
      title: "<strong>Mega!</strong> Du hast gewonnen:",
      content:
        `50 % Rabatt auf den <strong>glo™<br/> Home Stick Tray.</strong>`,
      img: prize2,
    },
  },
  birthdayglo_points_100_2025: {
    prizeNumber: 1,
    content: {
      title: "<strong>Mega!</strong> Du hast gewonnen:",
      content:
        "Glückwunsch! Du hast gewonnen:",
      points: 100,
    },
  },
  birthdayglo_points_50_2025: {
    prizeNumber: 7,
    content: {
      title: "<strong>Fantastisch!</strong> Du hast gewonnen:",
      content:
        "Glückwunsch! Du hast gewonnen:",
      points: 50,
    },
  },
};
